/**
 *
 * QuestionnairesForm
 *
 */

import React, { FunctionComponent, memo } from 'react';
import {
  accentColorPrim,
  accentColorSecond,
  fontColorSecond,
  white,
} from '../../../../assets/styledAssets/vars';
import { SectionWrap } from '../QuestionnaireSection/styles';
import { Wrap } from '../../../../assets/styledAssets/grid';
import { StyledRadioButton } from '../../../../components/FormField/styles';
import { Slider, SliderLabel } from '@progress/kendo-react-inputs';
import { StyledSliderWrap } from './styles';
import { AnswerType, Questionnaire } from '../../questionnaires';
import { editAnswer } from '../../Questionnaires.slice';

interface IProps {
  activeQuestionnaire?: Questionnaire;
  editAnswer?: typeof editAnswer;
}

const QuestionnairesForm: FunctionComponent<IProps> = ({
  activeQuestionnaire,
  editAnswer,
}) => {
  return (
    <>
      {activeQuestionnaire?.questionSeries?.map(
        (activeQItem, index: number) => (
          <Wrap
            key={`ser-${index}`}
            width={'100%'}
            flexDir={'column'}
            id={`section-${index}`}
          >
            <Wrap width={'100%'}>
              <SectionWrap>
                <Wrap
                  br={'1rem'}
                  bgColor={accentColorPrim}
                  flexDir={'column'}
                  flexWrap={'nowrap'}
                  width={'100%'}
                  margin={'0 0 3rem 0'}
                  padding={'2rem 0 0 0'}
                >
                  <Wrap
                    flexWrap={'nowrap'}
                    flexDir={'column'}
                    width={'100%'}
                    br={'1rem'}
                    bgColor={white}
                    borders={accentColorSecond}
                    padding={'2rem'}
                  >
                    {activeQItem.preText && (
                      <Wrap padding={'1rem 1.6rem'} fw={'bold'}>
                        {activeQItem.preText}
                      </Wrap>
                    )}
                    <Wrap width={'100%'} justifyCont={'space-between'}>
                      <Wrap width={'calc(100% - 16rem)'}>
                        {activeQItem.name && (
                          <Wrap
                            fs={'2rem'}
                            padding={'.8rem 1.6rem'}
                            fw={'bold'}
                          >
                            {activeQItem.name}
                          </Wrap>
                        )}
                      </Wrap>
                    </Wrap>
                    {activeQItem.postText && (
                      <Wrap
                        fs={'1.6rem'}
                        padding={'1rem 1.6rem'}
                        color={fontColorSecond}
                      >
                        {activeQItem.postText}
                      </Wrap>
                    )}
                  </Wrap>
                </Wrap>
              </SectionWrap>
            </Wrap>
            {activeQItem.questions.map((question, qIndx) => (
              <Wrap
                key={`item-${qIndx}`}
                padding={'2rem'}
                width={'100%'}
                bgColor={white}
                br={'1.2rem'}
                borders={accentColorSecond}
                margin={'0 0 3rem 0'}
              >
                <Wrap justifyCont={'center'} flexDir={'column'}>
                  {question.text && (
                    <Wrap
                      fs={'2rem'}
                      padding={'.8rem 1.6rem'}
                      fw={'bold'}
                      dangerouslySetInnerHTML={{ __html: question.text }}
                    />
                  )}
                  {question.preText && (
                    <Wrap
                      fs={'1.6rem'}
                      padding={'1rem 1.6rem'}
                      color={fontColorSecond}
                    >
                      {question.preText}
                    </Wrap>
                  )}
                </Wrap>
                {question.answers.map((answer, aIndex: number) => (
                  <Wrap width={'100%'} key={`answer-${aIndex}`}>
                    {question.answerType === AnswerType.RadioButton && (
                      <label
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          width: '100%',
                          padding: '1rem 1.6rem',
                        }}
                      >
                        <Wrap margin={'0 2rem 0 0'}>
                          <StyledRadioButton
                            name={question.id}
                            onChange={(e) =>
                              editAnswer &&
                              editAnswer({
                                seriesIdx: index,
                                questionIdx: qIndx,
                                answerIdx: aIndex,
                                answer: {
                                  ...answer,
                                  selected: true,
                                },
                              })
                            }
                          />
                        </Wrap>
                        <Wrap width={'calc(100% - 4rem)'}>{answer.text}</Wrap>
                      </label>
                    )}
                    {question.answerType === AnswerType.Range && (
                      <StyledSliderWrap>
                        <Slider step={1} defaultValue={7} min={1} max={10}>
                          {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((sliderItem) => (
                            <SliderLabel position={sliderItem}>
                              {sliderItem}
                            </SliderLabel>
                          ))}
                        </Slider>
                      </StyledSliderWrap>
                    )}
                  </Wrap>
                ))}
              </Wrap>
            ))}
          </Wrap>
        ),
      )}
    </>
  );
};

export default memo(QuestionnairesForm);
